<div class="container-fluid">
    <app-gene-table-selector [showGenomic] = false [showAssembly] = false [showRepseq]=true></app-gene-table-selector>
    <app-rep-gene-table-panel></app-rep-gene-table-panel>
</div>
